/* src/app/components/user-role/user-role.component.css */
/*# sourceMappingURL=user-role.component.css.map */
